import React, { useState, useCallback, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet';
import "./test.css";
import axios from "axios";
import CarouselT from "../CarouselT";
import BootstrapCard from "../../Components/CarouselCard/";
import Header from "../../Components/Header";
import WhatsAppIcon from "../../Components/wtsapicon/WhatsAppIcon";

const Test = () => {
    const [services, setServices] = useState([]);
    const [backgroundVideo, setBackgroundVideo] = useState([]);

    useEffect(() => {
        const video = document.getElementById("backgroundVideo");
        if (video) {
            video.playbackRate = 0.5;
        }
        fetchServiceType();
        fetchBackgroundVideo();
    }, []);

    const fetchServiceType = async () => {
        try {
            const response = await axios.get(
                "https://api.glyphqai.com/api/get-servicetype"
            );
            setServices(response.data.service_type);

        } catch (err) {
            console.error("Failed to fetch Services:", err);
        }
    };

    const fetchBackgroundVideo = async () => {
        try {
            const response = await axios.get(
                "https://api.glyphqai.com/api/get-backgroundvideo"
            );
            setBackgroundVideo(response.data.backgroundvideo[0].source);

        } catch (err) {
            console.error("Failed to fetch Services:", err);
        }
    };


    return (
        <>
            <Helmet>
                <title>Home Page - Services</title>
                <meta name="description" content="Explore our wide range of services including app development, web development, content writing, SEO, and voiceover services. Discover how we can help elevate your business." />
                <meta name="keywords" content="services, app development, web development, content writing, SEO, voiceover, background video" />
                <meta name="author" content="Glyph" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Test Page - Services" />
                <meta property="og:description" content="Explore our amazing services including app development, web development, and more. Discover how we can help elevate your business." />
                <meta property="og:image" content="https://api.glyphqai.com/uploads/backgroundvideo/preview-image.jpg" />
                <meta property="og:url" content="https://api.glyphqai.com" />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Test Page - Services" />
                <meta name="twitter:description" content="Explore our amazing services including app development, web development, and more. Discover how we can help elevate your business." />
                <meta name="twitter:image" content="https://api.glyphqai.com/uploads/backgroundvideo/preview-image.jpg" />
            </Helmet>
            <Header />
            <CarouselT services={services} backgroundVideo={backgroundVideo} />
            <WhatsAppIcon />
        </>
    );
};

export default Test;
